import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueAlertify from "vue-alertify";
import axios from "axios";
import vueResource from "vue-resource";
import VueClipboard from "vue-clipboard2";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/storage";
import "firebase/firebase-messaging";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import AudioVisual from 'vue-audio-visual'
import ProgressBar from 'vuejs-progress-bar';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueGeolocation from "vue-browser-geolocation";
import * as VueGoogleMaps from "vue2-google-maps";
import VueSignaturePad from "vue-signature-pad";
import VueTheMask from 'vue-the-mask';

const geofire = require("geofire");
const LottiePlayer = require("lottie-player-vue");

//PAGINA WEB
const firebaseConfigureWeb = {
  apiKey: "AIzaSyC68q9u_i-noaNnXKwKkDqrl2HcHuFMaIg",
  authDomain: "paginawebar.firebaseapp.com",
  databaseURL: "https://paginawebar.firebaseio.com",
  projectId: "paginawebar",
  storageBucket: "paginawebar.appspot.com",
  messagingSenderId: "155958669344",
  appId: "1:155958669344:web:9bbaa0e62e350b86080c45",
  measurementId: "G-3J698V719T",
};
const appWeb = firebase.initializeApp(firebaseConfigureWeb, "Secondary");
export const dbAuth = appWeb;
export const dbRealtime = appWeb.database().ref("SolicitudesGrabaciones");
export const dbRealtimeInformacion = appWeb.database().ref("SolicitudesInformacion");
export const dbRealtimeSolicitudInformacionAR = appWeb.database().ref("SolicitudesInformacionAR");
export const dbRealtimeUsers = appWeb.database().ref("Usuarios");
export const dbStorage = appWeb.storage();

//APP MOVIL
export const firebaseConfigAppMovil = {
  apiKey: "AIzaSyBtxohar0APihZUa7j9HHEvIFOTP4ZqC0k",
  authDomain: "appmovilar-1cb10.firebaseapp.com",
  databaseURL: "https://appmovilar-1cb10.firebaseio.com",
  projectId: "appmovilar-1cb10",
  storageBucket: "appmovilar-1cb10.appspot.com",
  messagingSenderId: "627872112052",
  appId: "1:627872112052:web:5e9048baa1addaf53ee6e1",
  measurementId: "G-JBMMDJGPSJ",
};
const appMovil = firebase.initializeApp(firebaseConfigAppMovil, "Third");
const dbAppMovil = appMovil.database();
export const dbRefAsistencias = dbAppMovil.ref("ClientBooking");
export const dbRefProveedor = dbAppMovil.ref("Users/Drivers");
export const dbRefCliente = dbAppMovil.ref("Users/Client");
export const dbRefHistory = dbAppMovil.ref("HistoryBooking");
export const dbRefToken = dbAppMovil.ref("Tokens");

let messaging = null;

if ('Notification' in window && 'ServiceWorker' in navigator) {
  messaging = appMovil.messaging();
  messaging.onMessage(function (payload) {
    console.log("onMessage", payload);
  })
} else {
  console.warn('Este navegador no soporta las APIs necesarias para Firebase Messaging.');
  // Puedes mostrar un mensaje al usuario o manejar el caso de navegadores no compatibles
}

export { messaging }
export const dbRefAssaAsistencias = dbAppMovil.ref("Assa/AsistenciasEnCurso");
export const dbCoordenadas = dbAppMovil.ref("Coordenadas");
export const dbDevoluciones = dbAppMovil.ref("Refunds");

//SISTEMA
const firebaseConfigSistema = {
  apiKey: "AIzaSyCbwBY_amZLQT8QZj_XjYAwUu3a-k1WF5Q",
  authDomain: "sistema-ar-3738a.firebaseapp.com",
  projectId: "sistema-ar-3738a",
  storageBucket: "sistema-ar-3738a.appspot.com",
  messagingSenderId: "588684931541",
  appId: "1:588684931541:web:45d2f766571363e34f8d5c",
  measurementId: "G-9PFYX0129D"
};
const sistemaAR = firebase.initializeApp(firebaseConfigSistema, "fourth");
export const storage = sistemaAR.storage().ref("files");
export const dbVersionSistema = sistemaAR.database().ref('DatosSistema/VersionSistema');

const dbRef = dbAppMovil.ref("active_drivers");
const dbRefWorking = dbAppMovil.ref("drivers_working");
export const geofireRef = new geofire.GeoFire(dbRef);
export const geofireRefWorking = new geofire.GeoFire(dbRefWorking);

Vue.use(VueSignaturePad);
Vue.use(VueTheMask);
Vue.use(VueGeolocation);
Vue.use(VueAlertify);
Vue.use(vueResource);
Vue.use(VueClipboard);
Vue.use(LottiePlayer);
Vue.use(VueSweetalert2);
Vue.use(AudioVisual)
Vue.use(ProgressBar)
Vue.use(Toast);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBtxohar0APihZUa7j9HHEvIFOTP4ZqC0k",
    libraries: "places",
  },
});
Vue.use(require('vue-cookies'))

axios.defaults.baseURL = process.env.VUE_APP_AXIOS;

// axios.interceptors.request.use(
//   function (config) {
//     const authToken = store.state.token;
//     if (authToken) {
//       config.headers.Authorization = `Bearer ${authToken}`;
//     }
//     return config;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

//Manejo Global de Unauthorized(401)
axios.interceptors.response.use(
  function (res) {
    return res;
  },
  function (error) {
    if (error.response && error.response.status == 401) {
      store.dispatch("salir");
    }

    return Promise.reject(error);
  }
)


new Vue({
  router,
  store,
  vuetify,
  VueAlertify,
  render: (h) => h(App),
}).$mount("#app");